// extracted by mini-css-extract-plugin
export default {"sizeContainer":"AssetSizeBox_sizeContainer__IB0yI"};